import { GFormSejour } from '@scripts/gform-sejour/g-form-sejour.js';

document.addEventListener('DOMContentLoaded', () => {
    const isGformSejour = document.querySelector('.gf-need-summary');
    if (!isGformSejour) return;

    new GFormSejour();

    // Customization for .new-form button
    const newForm = document.querySelector('.new-form');

    if (newForm) {
        const nextButton = newForm.querySelector('.gform_next_button');

        if (nextButton) {
            nextButton.value = 'Suivant';
        }
    }

    // Fonction pour gérer les liens de confirmation
    function setupConfirmationLinks () {
        const confirmationWrapper = document.querySelector('.gform_confirmation_wrapper');
        if (confirmationWrapper && !confirmationWrapper.dataset.linksSetup) {
            confirmationWrapper.dataset.linksSetup = 'true';

            confirmationWrapper.addEventListener('click', (e) => {
                const link = e.target.closest('a');
                if (link && link.href) {
                    e.preventDefault();
                    e.stopPropagation();
                    const targetUrl = link.href;

                    // Rediriger la page parente directement
                    if (window.top !== window) {
                        window.top.location.href = targetUrl;
                    } else {
                        window.location.href = targetUrl;
                    }
                }
            });
        }
    }

    // Essayer immédiatement
    setupConfirmationLinks();

    // Observer les changements du DOM pour détecter la confirmation AJAX
    const observer = new MutationObserver(() => {
        setupConfirmationLinks();
    });
    observer.observe(document.body, { childList: true, subtree: true });
});

if (typeof gform !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
    gform.addAction('gform_post_render', () => {
        const isGformSejour = document.querySelector('.gf-need-summary');
        if (!isGformSejour) return;
        new GFormSejour();
    });
}
